import { useContext, useEffect, useRef } from "react";
import { MainContext } from "../context/MainContextProvider";
import { Box } from "@mui/material";
import useComponentSize from "@rehooks/component-size";
import * as echarts from "echarts";

export const RopChart = (props: {
  option: any;
  onClick?: (params: any) => void;
}) => {
  const chart = useRef<HTMLDivElement | null>(null);
  const size = useComponentSize(chart);
  const isFromCardEditScreen = window.location.pathname.includes("edit");

  var { option } = props;

  let chartInstance: any = null;
  const { theme } = useContext(MainContext);
  const toggleTheme = () => {
    if (chartInstance) {
      chartInstance.dispose();
      chartInstance = echarts.init(chart.current, theme.name);
      renderChart();
    }
  };

  function renderChart() {
    if (!chart.current) return;
    const renderInstance = echarts.getInstanceByDom(chart.current);

    if (renderInstance) {
      chartInstance = renderInstance;
    } else {
      chartInstance = echarts.init(chart.current, theme.name);
    }

    chartInstance.off("click", handleChartClick);
    chartInstance.on("click", handleChartClick);

    chartInstance.setOption(
      {
        ...option,
        grid: { containLabel: true, top: 120, ...option.grid },
        legend: option.legend && {
          ...option.legend,
          top: 30,
          left: option.legend?.left ?? "left",
        },
      },
      { replaceMerge: ["series", "xAxis"] }
    );
  }

  function handleChartClick(params: any) {
    props.onClick && props.onClick(params);
  }

  useEffect(() => {
    renderChart();
    if (chartInstance != null) {
      chartInstance.resize({
        height: size.height,
      });
    }
  }, [size, option]);

  useEffect(() => {
    toggleTheme();
  }, [theme]);

  return (
    <Box
      ref={chart}
      sx={{
        width: "100%",
        height: "100%",
        minHeight: isFromCardEditScreen ? "400px" : undefined,
      }}
    />
  );
};
